import {
  Banktransfer,
  PaymentResponse,
  PurchaseResponse
} from "@/interfaces/purchase";
import { Content, Feed } from "@/interfaces/content";
import { UserAccount } from "@/interfaces/user";
import BaseApiClient from "@/api/base";

export class ApiClient extends BaseApiClient {
  public getAccountInfo(): Promise<UserAccount> {
    return this.get<UserAccount>("/user/account");
  }

  public setUserName(name: string): Promise<UserAccount> {
    return this.get<UserAccount>("/user/set_name", { name });
  }

  public getFeed(): Promise<Feed> {
    return this.get<Feed>("/content/feed");
  }

  public getRecommendations(
    content_id?: string,
    size: number = 6
  ): Promise<Content[]> {
    const params: any = { size };
    if (content_id) {
      params["content_id"] = content_id;
    }
    return this.get<Content[]>("/content/recommendations", params);
  }

  public getPurchases(): Promise<Content[]> {
    return this.get<Content[]>("/content/videos", {
      purchased: true
    });
  }

  public getVideosByCategory(category: string): Promise<Content[]> {
    return this.get<Content[]>("/content/videos", {
      tags_one_of: category
    });
  }

  public getOpenBanktransfers(): Promise<Banktransfer[]> {
    return this.get<Banktransfer[]>("/payment/charge/open_banktransfers");
  }

  public cancelOpenBanktransfers(cancel: string): Promise<Banktransfer[]> {
    return this.get<Banktransfer[]>("/payment/charge/open_banktransfers", {
      cancel: cancel
    });
  }

  public getCategories(type: string = "video"): Promise<string[]> {
    return this.get(`/content/list_categories`, {
      content_type: type
    });
  }

  public getTags(type: string = "video"): Promise<string[]> {
    return this.get(`/content/list_tags`, {
      content_type: type
    });
  }

  public getContent(id: string): Promise<Content> {
    return this.get<Content>(`/content/id/${id}`);
  }

  public purchaseContentWithCoins(id: string): Promise<PurchaseResponse> {
    return this.get<PurchaseResponse>(`/payment/purchase/${id}`);
  }

  public initiatePayment(
    provider: string,
    paymentOption: string,
    amount: number,
    coins: number,
    calledFrom: string
  ): Promise<PaymentResponse | Banktransfer> {
    return this.get<PaymentResponse>(`/payment/charge/${provider}`, {
      payment_option: paymentOption,
      amount: amount,
      coins: coins,
      called_from: calledFrom
    });
  }

  public verifyPayment(provider: string, paymentId: string): Promise<string> {
    if (provider === "paysafecard") {
      return this.get<string>(`/payment/charge/paysafecard_check/${paymentId}`);
    }
    throw new Error(`Unsupported provider: '${provider}'`);
  }

  public getSofortIdentLink(): Promise<string> {
    return this.get<string>("/age/sofort/link");
  }
}
